<template>
	<div class="container">
		<div class="">
			<div class="table_path">
				<p class="path_title">表格</p>
				<div class="theader">
                    <div class="" v-for="(item, index) in col" :key="index" :style="{ width: item.width }">{{ item.label }}</div>
                </div>
				<p class="title">总库存</p>
				<div class="tbody" style="height: 117px;">
                    <div class="" v-for="(row,index) in list1" :key="'row_'+index">
                        <div :class=" (item.field == 'field4' || item.field == 'field6' || item.field == 'field8' || item.field == 'field10') ? row[item.field] < 0 ? 'red' : 'green' : '' " v-for="(item,ind) in col" :style="{ width: item.width }" :key="'item_'+ind">
                            {{ row[item.field] }}
                        </div>
                    </div>
                </div>
				<p class="title">区域指数</p>
				<div class="tbody" style="height: 200px;">
                    <div v-for="(row,index) in list2" :key="'row_'+index">
                        <div :class=" (item.field == 'field4' || item.field == 'field6' || item.field == 'field8' || item.field == 'field10') ? row[item.field] < 0 ? 'red' : 'green' : '' " v-for="(item,ind) in col" :style="{ width: item.width }" :key="'item_'+ind">
                            {{ row[item.field] }}
                        </div>
                    </div>
                </div>
				<div class="filter_header title">
					品种指数
                    <div class="btn_tabs">
						<div :class="{ current : active == '1' }" @click="active = '1'">非洲材</div>
						<div :class="{ current : active == '2' }" @click="active = '2'">北美材</div>
						<div :class="{ current : active == '3' }" @click="active = '3'">欧洲材</div>
						<div :class="{ current : active == '4' }" @click="active = '4'">松木</div>
					</div>
				</div>
                <div class="tbody" style="height: 255px;">
                    <div  v-for="(row,index) in list3" :key="'row_'+index">
                        <div :class=" (item.field == 'field4' || item.field == 'field6' || item.field == 'field8' || item.field == 'field10') ? row[item.field] < 0 ? 'red' : 'green' : '' " v-for="(item,ind) in col" :style="{ width: item.width }" :key="'item_'+ind">
                            {{ row[item.field] }}
                        </div>
                    </div>
                </div>
			</div>
			<div class="echart_path">
				<p class="path_title">线性图</p>
				<div class="show_box">
					<p class="filter_header">树种</p>
					<div class="btn_tabs">
						<div :class="{ current : active == '1' }" @click="active = '1'">非洲材</div>
						<div :class="{ current : active == '2' }" @click="active = '2'">北美材</div>
						<div :class="{ current : active == '3' }" @click="active = '3'">欧洲材</div>
						<div :class="{ current : active == '4' }" @click="active = '4'">松木</div>
					</div>
					<p class="filter_header">时间</p>
                    <div class="tabs">
						<div :class="{ current : current == '1' }" @click="current = '1'">1周</div>
						<div :class="{ current : current == '2' }" @click="current = '2'">1个月</div>
						<div :class="{ current : current == '3' }" @click="current = '3'">3个月</div>
						<div :class="{ current : current == '4' }" @click="current = '4'">6个月</div>
						<div :class="{ current : current == '5' }" @click="current = '5'">1年</div>
						<div :class="{ current : current == '6' }" @click="current = '6'">2年</div>
					</div>
					<div class="" id="tline">

					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.container{
		display: flex; flex-direction: column; align-items: stretch; height: 100%; overflow: auto; border-top:11px solid #EEEFF2; border-left: 11px solid #EEEFF2;
        p{ padding: 0; margin: 0; }
		& > div{ flex: 1; display: flex;  height: 100%; width: 1808px; padding: 0 20px; padding-top: 40px; background-color: #fff;  text-align: left; }
        .path_title{ font-size:16px; font-weight:bold; line-height:22px; color: #000; margin-bottom: 13px; }
		.table_path{
            width:910px; margin-right: 20px;
            .title{ font-size: 16px; line-height: 22px; font-weight: bold; margin-top: 10px; }
            .theader{ width:100%; height:36px; background:rgba(232,234,243,1); opacity:1; border-radius:3px; line-height: 1; padding: 9px; display: flex; align-items: center; font-size: 14px; font-weight: bold; color: #000; }
            .tbody{
                width:100%; background:rgba(232,234,243,1); opacity:1; border-radius:3px; line-height: 1; padding: 9px 0; font-size: 12px; color: #000; padding: 9px; overflow: auto; margin-top: 5px;
                & > div {
                    width:100%; display: flex; align-items: center;
                    & > div{ line-height: 17px; padding: 2px 10px; border-bottom:1px solid #CCCCCC; }
                    & + div{ margin-top: 3px; }
                }
            }
            .filter_header{
                display: flex; align-items: center;
                .btn_tabs{ margin-left: 25px; }
            }
        }
        .tabs{
            display: flex; align-items: center; justify-content: space-between; font-size: 14px;
            & > div{ border-bottom: 4px solid transparent; padding: 5px; cursor: pointer; }
            & > div.current{ border-bottom: 4px solid #B21111; }
        }
        .btn_tabs{
            display: flex; align-items: center; font-size: 12px;
            & > div{
                min-width:60px; height:28px; background:rgba(255,255,255,1); border:1px solid rgba(102,102,102,1); opacity:1; border-radius:3px; line-height: 28px; padding: 0 12px; text-align: center; cursor: pointer;
                &.current{
                    border: 1px solid #B21111; position: relative;
                    // &::after{ display: block; content: ""; position: absolute; border-radius: 50%; width:10px; height:10px; background:rgba(178,17,17,1); bottom: 3px; right: 3px;}
                }
                & + div{ margin-left: 20px; }
            }
        }
		.echart_path{
			.show_box{
				width:830px; height:724px; background:rgba(244,245,249,1); border-radius:3px; display: flex; flex-direction: column; align-items: stretch; padding: 18px 30px;
                .filter_header{ font-size:14px;  font-weight:bold; line-height:20px; color: #000; margin-bottom: 17px; }
                .btn_tabs{ margin-bottom: 33px; }
			}
		}
		#tline{ width: 100%; flex: 1; }
	}
</style>

<script>
export default {
	data() {
		return {
			col:[
                {
                    field : "field1",
                    label : "",
                    width:"95px"
                },
                {
                    field : "field2",
                    label : "本日",
                    width:"95px"
                },
                {
                    field : "field3",
                    label : "昨日",
                    width:"95px"
                },
                {
                    field : "field4",
                    label : "日环比",
                    width:"95px"
                },
                {
                    field : "field5",
                    label : "上周",
                    width:"95px"
                },
                {
                    field : "field6",
                    label : "周环比",
                    width:"95px"
                },
                {
                    field : "field7",
                    label : "上月度",
                    width:"95px"
                },
                {
                    field : "field8",
                    label : "与上月比",
                    width:"95px"
                },
                {
                    field : "field9",
                    label : "去年同期",
                    width:"95px"
                },
                {
                    field : "field10",
                    label : "",
                    width:"95px"
                },
            ],
            list1 : [
                {
					field1 : "非洲材",
					field2 : 143.52,
					field3 : 143.52,
					field4 : -0.52,
					field5 : 143.52,
					field6 : -0.52,
					field7 : 143.52,
					field8 : -0.52,
					field9 : 143.52,
					field10 : -0.52,
                },
				{
					field1 : "北美材",
					field2 : 152.11,
					field3 : 152.11,
					field4 : 0.11,
					field5 : 152.11,
					field6 : 0.11,
					field7 : 152.11,
					field8 : 0.11,
					field9 : 152.11,
					field10 : 0.11,
                },
				{
					field1 : "欧洲材",
					field2 : 120.25,
					field3 : 120.25,
					field4 : -0.52,
					field5 : 120.25,
					field6 : -0.52,
					field7 : 120.25,
					field8 : -0.52,
					field9 : 120.25,
					field10 : -0.52,
                },
				{
					field1 : "松木材",
					field2 : 160.55,
					field3 : 160.55,
					field4 : -0.52,
					field5 : 160.55,
					field6 : -0.52,
					field7 : 160.55,
					field8 : -0.52,
					field9 : 160.55,
					field10 : -0.52,
                }
            ],
			list2 : [
                {
					field1 : "华东",
					field2 : 143.52,
					field3 : 143.52,
					field4 : -0.52,
					field5 : 143.52,
					field6 : -0.52,
					field7 : 143.52,
					field8 : -0.52,
					field9 : 143.52,
					field10 : -0.52,
                },
				{
					field1 : "华南",
					field2 : 152.11,
					field3 : 152.11,
					field4 : 0.11,
					field5 : 152.11,
					field6 : 0.11,
					field7 : 152.11,
					field8 : 0.11,
					field9 : 152.11,
					field10 : 0.11,
                },
				{
					field1 : "华北",
					field2 : 120.25,
					field3 : 120.25,
					field4 : -0.52,
					field5 : 120.25,
					field6 : -0.52,
					field7 : 120.25,
					field8 : -0.52,
					field9 : 120.25,
					field10 : -0.52,
                },
				{
					field1 : "中南",
					field2 : 160.55,
					field3 : 160.55,
					field4 : -0.52,
					field5 : 160.55,
					field6 : -0.52,
					field7 : 160.55,
					field8 : -0.52,
					field9 : 160.55,
					field10 : -0.52,
                },
				{
					field1 : "东北",
					field2 : 143.52,
					field3 : 143.52,
					field4 : -0.52,
					field5 : 143.52,
					field6 : -0.52,
					field7 : 143.52,
					field8 : -0.52,
					field9 : 143.52,
					field10 : -0.52,
                },
				{
					field1 : "西南",
					field2 : 152.11,
					field3 : 152.11,
					field4 : 0.11,
					field5 : 152.11,
					field6 : 0.11,
					field7 : 152.11,
					field8 : 0.11,
					field9 : 152.11,
					field10 : 0.11,
                },
				{
					field1 : "西北",
					field2 : 120.25,
					field3 : 120.25,
					field4 : -0.52,
					field5 : 120.25,
					field6 : -0.52,
					field7 : 120.25,
					field8 : -0.52,
					field9 : 120.25,
					field10 : -0.52,
                },
            ],
			list3 : [
                {
					field1 : "小斑马",
					field2 : 143.52,
					field3 : 143.52,
					field4 : -0.52,
					field5 : 143.52,
					field6 : -0.52,
					field7 : 143.52,
					field8 : -0.52,
					field9 : 143.52,
					field10 : -0.52,
                },
				{
					field1 : "大斑马",
					field2 : 152.11,
					field3 : 152.11,
					field4 : 0.11,
					field5 : 152.11,
					field6 : 0.11,
					field7 : 152.11,
					field8 : 0.11,
					field9 : 152.11,
					field10 : 0.11,
                },
				{
					field1 : "红斑马",
					field2 : 120.25,
					field3 : 120.25,
					field4 : -0.52,
					field5 : 120.25,
					field6 : -0.52,
					field7 : 120.25,
					field8 : -0.52,
					field9 : 120.25,
					field10 : -0.52,
                },
				{
					field1 : "冰糖果",
					field2 : 160.55,
					field3 : 160.55,
					field4 : -0.52,
					field5 : 160.55,
					field6 : -0.52,
					field7 : 160.55,
					field8 : -0.52,
					field9 : 160.55,
					field10 : -0.52,
                },
				{
					field1 : "综合欢",
					field2 : 143.52,
					field3 : 143.52,
					field4 : -0.52,
					field5 : 143.52,
					field6 : -0.52,
					field7 : 143.52,
					field8 : -0.52,
					field9 : 143.52,
					field10 : -0.52,
                },
				{
					field1 : "巴新材",
					field2 : 152.11,
					field3 : 152.11,
					field4 : 0.11,
					field5 : 152.11,
					field6 : 0.11,
					field7 : 152.11,
					field8 : 0.11,
					field9 : 152.11,
					field10 : 0.11,
                },
				{
					field1 : "所罗门材",
					field2 : 120.25,
					field3 : 120.25,
					field4 : -0.52,
					field5 : 120.25,
					field6 : -0.52,
					field7 : 120.25,
					field8 : -0.52,
					field9 : 120.25,
					field10 : -0.52,
                },
				{
					field1 : "奥古曼",
					field2 : 160.55,
					field3 : 160.55,
					field4 : -0.52,
					field5 : 160.55,
					field6 : -0.52,
					field7 : 160.55,
					field8 : -0.52,
					field9 : 160.55,
					field10 : -0.52,
                },
				{
					field1 : "TB",
					field2 : 143.52,
					field3 : 143.52,
					field4 : -0.52,
					field5 : 143.52,
					field6 : -0.52,
					field7 : 143.52,
					field8 : -0.52,
					field9 : 143.52,
					field10 : -0.52,
                },
            ],
            current : 0,
            active : 1,
            tline : {}
		}
	},
	components:{
	},
	computed:{
	},
	created(){
	},
	mounted(){
        this.drawLine();
	},
	methods: {
        drawLine(){
			if (this.tline.hasOwnProperty("id")) {
				this.tline.dispose();
			}
			this.tline = window.echarts.init(document.getElementById('tline'));
			let option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data:['华东','华北','华南','中南','东北']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {}
                //     }
                // },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一','周二','周三','周四','周五','周六','周日']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name:'华东',
                        type:'line',
                        stack: '总量',
                        data:[120, 132, 101, 134, 90, 230, 210]
                    },
                    {
                        name:'华北',
                        type:'line',
                        stack: '总量',
                        data:[220, 182, 191, 234, 290, 330, 310]
                    },
                    {
                        name:'华南',
                        type:'line',
                        stack: '总量',
                        data:[150, 232, 201, 154, 190, 330, 410]
                    },
                    {
                        name:'中南',
                        type:'line',
                        stack: '总量',
                        data:[320, 332, 301, 334, 390, 330, 320]
                    },
                    {
                        name:'东北',
                        type:'line',
                        stack: '总量',
                        data:[820, 932, 901, 934, 1290, 1330, 1320]
                    }
                ]
            };
			this.tline.setOption(option);
		},
	},
	watch:{
	}
}
</script>
